module.exports = "https://trybtryb-legacy.web.app/img/forward.e567e671.svg";